import { createRouter, createWebHistory, createWebHashHistory } from 'vue-router';
import { Capacitor } from '@capacitor/core';
// import { SplashScreen } from '@capacitor/splash-screen';
// import { StatusBar } from '@capacitor/status-bar';
// import { Capacitor } from '@capacitor/core';
import { getAuth, onAuthStateChanged } from 'firebase/auth';
// import Cookies from 'js-cookie';
import store from './store';

import { getDoc, doc } from 'firebase/firestore';
import { db } from '@/main';

// 🔥 Guard admin réutilisable
// const requireAdmin = async (to, from, next) => {
//     const auth = getAuth();
//     const user = auth.currentUser;
//     if (!user) { next({ name: 'homePage' }); return; }
//     try {
//         const snap = await getDoc(doc(db, 'users', user.uid));
//         if (snap.exists() && snap.data().admin === true) {
//             next();
//         } else {
//             next({ name: 'homePage' });
//         }
//     } catch (e) {
//         next({ name: 'homePage' });
//     }
// };

const requireAdmin = async (to, from, next) => {
    const auth = getAuth();
    const user = auth.currentUser;
    const isNative = Capacitor.isNativePlatform();
    const isLocalhost = window.location.hostname === 'localhost' || 
                        window.location.hostname === '127.0.0.1';
    const fallback = (!isNative && !isLocalhost) 
        ? { name: 'DisplayInstallAppPage' } 
        : { name: 'homePage' };

    if (!user) { next(fallback); return; }
    try {
        const snap = await getDoc(doc(db, 'users', user.uid));
        if (snap.exists() && snap.data().admin === true) {
            next();
        } else {
            next(fallback);
        }
    } catch (e) {
        next(fallback);
    }
};

const history = Capacitor.isNativePlatform()
  ? createWebHashHistory()
  : createWebHistory()
// Créer le router
const router = createRouter({
  history,
  routes: [
    // LES ROUTES DISPONIBLES QUAND NON CONNECTER
 
    {
      path: "/", name: 'unConnected', component: () => import("./pages/UnConnected-Page.vue"),

      meta: {
          requiresAuth: false,
      },
    },
    
    {
      path: "/ForgotPasswordPage", component: () => import("./pages/Forgot-Password-Page.vue"),
   meta: {
     requiresAuth: false,
     transition: 'slide-left' , // Transition gauche à droite 
     
      },

    },

    //LES ROUTES DISPONIBLES QUAND CONNECTER

    { path: "/HomePage", name: 'homePage', component: () => import("./pages/Home-Page.vue"),
    meta: {
          requiresAuth: false,
      },
    },

    {
  path: "/install",
  name: 'DisplayInstallAppPage',
  component: () => import("./pages/Display-Install-App-Page.vue"),
  meta: { requiresAuth: false }
},

    {
      path: '/ParametrePage', name: 'ParametrePage', component: () => import('./pages/Parametre-Page.vue'),
  
   meta: {
          requiresAuth: false,
      },
    },

     {

      path: '/EdeNouGrandi', name: 'EdeNouGrandiPage', component: () => import('./pages/Ede-Nou-Grandi-Page.vue'),
  
   meta: {
          requiresAuth: true,
      },
    },

        {
      path: '/FaqPage', name: 'Faq-Page', component: () => import('./pages/Faq-page.vue'),
  
   meta: {
          requiresAuth: false,
      },
    },

     {
      path: '/WebmConverter', name: 'webm-con', component: () => import('./pages/Parametre-Page.vue'),
  
   meta: {
          requiresAuth: false,
      },
    },
     
      { path: "/BookPropositionPage/:id", name: 'proposition-page', component: () => import("./pages/Book-Proposition-Page.vue"),
    meta: {
          requiresAuth: false,
      },
    },
        
    { path: "/AdminPage", name: 'adminPage', component: () => import("./pages/Admin-Page.vue"),
    meta: {
      requiresAuth: true,
     transition: 'slide-left' , // Transition gauche à droite 
      
      },
        beforeEnter: requireAdmin
    },
        
      { path: "/PolitiqueConfidentialitePage", name: 'politique-page', component: () => import("./pages/Politique-Confidentialite-Page.vue"),
    meta: {
      requiresAuth: false,
     transition: 'slide-left' , // Transition gauche à droite 
      
        }, },

  { path: "/PolitiqueUserPage", name: 'politique-user-page', component: () => import("./pages/Politique-User-Page.vue"),
    meta: {
      requiresAuth: false,
     transition: 'slide-left' , // Transition gauche à droite 
      
      },
    },
      
        
          { path: "/ConditionUtilisationPage", name: 'condition-page', component: () => import("./pages/Condition-Utilisation-Page.vue"),
    meta: {
      requiresAuth: false,
     transition: 'slide-left' , // Transition gauche à droite 
      
        }, },

         { path: "/ConditionUserPage", name: 'condition-user-page', component: () => import("./pages/Condition-User-Page.vue"),
    meta: {
      requiresAuth: false,
     transition: 'slide-left' , // Transition gauche à droite 
      
      },
    },
        
      
      { path: "/WhoAreWeUnconnectPage", name: 'who-are-we-unconnect-page', component: () => import("./pages/Who-Are-We-Unconnect-Page.vue"),
    meta: {
      requiresAuth: false,
     transition: 'slide-left' , // Transition gauche à droite 
      
      },
    },
        

     { path: "/UserSearchPage", name: 'user-search-page', component: () => import("./pages/User-Search-Page.vue"),
    meta: {
          requiresAuth: true,
       },  
    
        beforeEnter: requireAdmin
    },

       { path: "/NewUserSearchPage", name: 'new-user-search-page', component: () => import("./pages/New-User-Search-Page.vue"),
    meta: {
          requiresAuth: true,
      },  
    },

        { path: "/TrophyAward", name: 'trophy-award', component: () => import("./pages/Trophy-Award.vue"),
    meta: {
          requiresAuth: true,
      },  
    },

       { path: "/ModifyTrophy/:id", name: 'modify-trophy', component: () => import("./pages/Modify-Trophy.vue"),
    meta: {
          requiresAuth: true,
      },  
    },

       { path: "/CreateAward", name: 'create-award', component: () => import("./pages/Create-Award.vue"),
    meta: {
          requiresAuth: true,
      },  
    },

     { path: "/BookSearchPage", name: 'book-search-page', component: () => import("./pages/Book-Search-Page.vue"),
    meta: {
          requiresAuth: true,
      },  
    },

     { path: "/BookSearchSmsPage", name: 'book-search-sms-page', component: () => import("./pages/Book-Search-Sms-Page.vue"),
    meta: {
          requiresAuth: true,
       },  
        beforeEnter: requireAdmin
    },

    

    { path: "/LibraryPage", name: "LibraryPage", component: () => import("./pages/Library-Page.vue"),
    meta: {
          requiresAuth: false,
      },
    },

    { path: "/LibraryPageSearch", name: "LibraryPageSearch", component: () => import("./pages/Library-Page-Search.vue"),
    meta: {
          requiresAuth: false,
      },
    },
      { path: "/LibraryPageSearchSms", name: "LibraryPageSearchSms", component: () => import("./pages/Library-Page-Search-Sms.vue"),
    meta: {
          requiresAuth: false,
      },
    },

       { path: "/LibraryNewPage", name: "LibraryNewPage", component: () => import("./pages/Library-New-Page.vue"),
    meta: {
          requiresAuth: true,
      },
    },
       
        { path: "/LibraryPageOffline", name: "LibraryPageOffline", component: () => import("./pages/Library-Page-Offline.vue"),
    meta: {
          requiresAuth: false,
          },
    
       beforeEnter: (to, from, next) => {
    const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
    if (!Capacitor.isNativePlatform() && !isLocalhost) {
        next({ name: 'unConnected' });
    } else {
        next();
    }
}
    },

      { path: "/ContactPage", name: 'contact-page', component: () => import("./pages/Contact-Page.vue"),
    meta: {
      requiresAuth: false,
     transition: 'slide-left' , // Transition gauche à droite 
      
        }, },

    { path: "/PublishPage", name: 'publishPage', component: () => import("./pages/Publish-Page.vue"),
    meta: {
          requiresAuth: false,
      },
    },

     { path: "/PublishPageOffline", name: 'publishPageOffline', component: () => import("./pages/Publish-Page-Offline.vue"),
    meta: {
          requiresAuth: false,
       },
    beforeEnter: (to, from, next) => {
    const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
    if (!Capacitor.isNativePlatform() && !isLocalhost) {
        next({ name: 'unConnected' });
    } else {
        next();
    }
}
    
    },


         { path: "/NotificationsPage", name:'NotificationsPage', component: () => import("./pages/Notifications-Page.vue"),
    meta: {
          requiresAuth: false,
      },
    },

       { path: "/NotificationsNewPage", name:'NotificationsNewPage', component: () => import("./pages/Notifications-New-Page.vue"),
    meta: {
          requiresAuth: false,
      },
    },

          { path: "/NotificationsDraftPage/:id", name:'notifications-draft-page', component: () => import("./pages/Notifications-Draft-Page.vue"),
    meta: {
      requiresAuth: true,
     transition: 'slide-left' , // Transition gauche à droite 
      
      },
    },

    
    {
      path: "/NotificationsPageOffline", name: 'NotificationsPageOffline',
      component: () => import("./pages/Notifications-Page-Offline.vue"),
    meta: {
          requiresAuth: false,
      },
    
     beforeEnter: (to, from, next) => {
    const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
    if (!Capacitor.isNativePlatform() && !isLocalhost) {
        next({ name: 'unConnected' });
    } else {
        next();
    }
}
    },

       { path: "/ProfilPage", name: 'profilPage', component: () => import("./pages/Profil-Page.vue"),
    meta: {
          requiresAuth: true,
      },
    },

      { path: "/ProfilPageOffline", name: 'profilPageOffline', component: () => import("./pages/Profil-Page-Offline.vue"),
    meta: {
          requiresAuth: false,
        },
      beforeEnter: (to, from, next) => {
    const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
    if (!Capacitor.isNativePlatform() && !isLocalhost) {
        next({ name: 'unConnected' });
    } else {
        next();
    }
}
    },

 

      { path: "/ModifyInfoUsers", name: 'modify-info-users', component: () => import("./components/connected-components/Modify-Info-Users.vue"),
    meta: {
      requiresAuth: true,
     transition: 'slide-left' , // Transition gauche à droite 
      
      },
    },

      { path: "/RatingAppPage", name: 'rating-app-page', component: () => import("./pages/Rating-App-Page.vue"),
    meta: {
      requiresAuth: true,
     transition: 'slide-left' , // Transition gauche à droite 
      
      },
    },


        { path: "/FormNewPublishStoryPageSms", component: () => import("./pages/Form-New-Publish-Story-Page-Sms.vue"),
    meta: {
      requiresAuth: true,
     transition: 'slide-left' , // Transition gauche à droite 
      
          },
    
        beforeEnter: requireAdmin
    },

    { path: "/FormChaptersPublishBis/:id", name: 'form-chapters-publish-bis', component: () => import("./components/connected-components/Form-Chapters-Publish-Bis.vue"),
    meta: {
          requiresAuth: true,
      },
    },

    {
      path: '/drama-stats/:id', name: 'drama-stats', component: () => import('./components/connected-components/Drama-Stats.vue'),
      props: true,
        meta: {
          requiresAuth: true,
      },

    },

    {
    path: '/user-stats',
    name: 'user-stats',
    component: () => import('./components/connected-components/User-Stats.vue'),
      meta: { requiresAuth: true },
        beforeEnter: requireAdmin
},

     { path: "/FormChapters/:id", name: 'form-chapters', component: () => import("./components/connected-components/Form-Chapters-before-cloudflare.vue"),
    meta: {
          requiresAuth: true,
      },
    },

     { path: "/TransactionHistorique", name: 'TransactionHistorique', component: () => import("./components/connected-components/Transaction-Historique.vue"),
    meta: {
          requiresAuth: false,
      },
    },

    { path: '/Subscription', name: 'SubscriptionPage', component: () => import('./components/connected-components/Subscription-Page.vue'),
   meta: {
          requiresAuth: false,
      },
    },

     { path: "/FormChaptersSms/:id", name: 'chapter-sms', component: () => import("./components/connected-components/Form-Chapters-Sms.vue"),
    meta: {
          requiresAuth: true,
       },
        beforeEnter: requireAdmin
    },

      { path: "/ModifyBookInfoGeneralBis/:id", name: 'modify-book-info-general-bis', component: () => import("./components/connected-components/Modify-Book-Info-General-Bis.vue"),
    meta: {
          requiresAuth: true,
      },
    },

    
      { path: "/ModifyBookSms/:id", name: 'modify-book-sms', component: () => import("./components/connected-components/Modify-Book-Sms.vue"),
    meta: {
          requiresAuth: true,
      },
    },

       { path: "/ModifyPages/:id", name: 'modify-pages', component: () => import("./components/connected-components/Modify-Pages.vue"),
    meta: {
      requiresAuth: true,
     transition: 'slide-left' , // Transition gauche à droite 
      
      },
    },


      { path: "/ModifyOrderOfPages/:id", name: 'modify-order-of-pages', component: () => import("./components/connected-components/Modify-Order-Of-Pages.vue"),
    meta: {
      requiresAuth: true,
     transition: 'slide-left' , // Transition gauche à droite 
      
      },
    },

     { path: "/ModifyPagesUsers/:id", name: 'modify-pages-users', component: () => import("./components/connected-components/Modify-Pages-Users.vue"),
    meta: {
          requiresAuth: true,
      },
    },

     { path: "/ModifyPagesUsersSms/:id", name: 'modify-pages-users-sms', component: () => import("./components/connected-components/Modify-Pages-Users-Sms.vue"),
    meta: {
          requiresAuth: true,
       },
    
        beforeEnter: requireAdmin
    },

      { path: "/PublishPagesUsers/:id", name: 'publish-pages-users', component: () => import("./components/connected-components/Publish-Pages-Users.vue"),
    meta: {
          requiresAuth: true,
      },
    },


     { path: "/DeletePages/:id", name: 'delete-pages', component: () => import("./components/connected-components/Delete-Pages.vue"),
    meta: {
      requiresAuth: true,
     transition: 'slide-left' , // Transition gauche à droite 
      
      },
    },


    
     { path: "/DeletePagesUsers/:id", name: 'delete-pages-users', component: () => import("./components/connected-components/Delete-Pages-Users.vue"),
    meta: {
          requiresAuth: true,
      },
    },



      { path: "/ModifyEachPage/:id/:chapterId", name: 'modify-each-page', component: () => import("./components/connected-components/Modify-Each-Page-before-cloudflare.vue"),
    meta: {
          requiresAuth: true,
        },
        beforeEnter: requireAdmin
    },

     { path: "/ModifyEachPageSms/:id/:chapterId", name: 'modify-each-page-sms', component: () => import("./components/connected-components/Modify-Each-Page-Sms.vue"),
    meta: {
          requiresAuth: true,
       },
        beforeEnter: requireAdmin
    },


       { path: "/PreviewBeforeModifySms/:id/:chapterId", name: 'preview-before-modify-sms', component: () => import("./components/connected-components/Preview-Before-Modify-Sms.vue"),
    meta: {
          requiresAuth: true,
         },
        beforeEnter: requireAdmin
    },

   

     { path: "/SendNotificationsByAdmin/", name: 'send-notifications-by-admin', component: () => import("./components/connected-components/Send-Notifications-By-Admin.vue"),
    meta: {
          requiresAuth: true,
      },
    },

      { path: "/SendLink/", name: 'send-link', component: () => import("./components/connected-components/Send-Link.vue"),
    meta: {
          requiresAuth: true,
      },
    },

       { path: "/SendNotificationsByOneUser/", name: 'send-notifications-by-one-user', component: () => import("./components/connected-components/Send-Notifications-By-One-User.vue"),
    meta: {
          requiresAuth: true,
      },
    },

     { path: "/SendNotificationsByAdminToNewUsers/", name: 'send-notifications-by-admin-to-newUsers', component: () => import("./components/connected-components/Send-Notifications-By-Admin-To-newUsers.vue"),
    meta: {
          requiresAuth: true,
      },
    },

    



 { path: "/ParametersBookSms/:id", name: 'parameters-book-sms', component: () => import("./components/connected-components/Parameters-Book-Sms.vue"),
    meta: {
      requiresAuth: true,
      
   },
    
        beforeEnter: requireAdmin
    },

     { path: "/WalletPage", name: 'WalletPage', component: () => import("./components/connected-components/Wallet-Page.vue"),
    meta: {
      requiresAuth: false,
      
      },
    },

 {
   path: '/notificationDisplay', name: 'notification-display',
   component: () => import("./components/connected-components/Notification-Display.vue"),
    meta: {
          requiresAuth: true,
      },
    },
     
      {
        path: '/bookDetails/:id', name: 'book-details',  props: true, 
        component: () => import("./components/connected-components/Book-Details.vue"),
    meta: {
      requiresAuth: false,
      
      },
    },



        {

       path: '/userDetails/:id', name: 'user-details',  props: true, 
        component: () => import("./components/connected-components/User-Details.vue"),
    meta: {
      requiresAuth: false,
     transition: 'slide-left' , // Transition gauche à droite 
      
      },
    },

  
    
   

        {

       path: '/EachUserDetails/:id', name: 'each-user-details',  props: true, 
        component: () => import("./components/connected-components/Each-User-Details.vue"),
    meta: {
          requiresAuth: true,
      },
    },
  
      {

       path: '/EachBookDetails/:id', name: 'each-book-details',  props: true, 
        component: () => import("./components/connected-components/Each-Book-Details.vue"),
    meta: {
          requiresAuth: true,
        },
        beforeEnter: requireAdmin
    },
 {

       path: '/EachBookDetailsSms/:id', name: 'each-book-details-sms',  props: true, 
        component: () => import("./components/connected-components/Each-Book-Details-Sms.vue"),
    meta: {
          requiresAuth: true,
   },
        beforeEnter: requireAdmin
    },
       
  
         
              {
            path: '/book-sms/:id/:chapterId?/:videoTime?', name: 'book-sms', component: () => import("./components/connected-components/Book-Sms.vue"),
    meta: {
      requiresAuth: false,
     transition: 'slide-left' , // Transition gauche à droite 
      
                },
  beforeEnter: (to, from, next) => {
    const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
    if (!Capacitor.isNativePlatform() && !isLocalhost) {
        next({ name: 'unConnected' });
    } else {
        next();
    }
}
    },

  ],
});

// const getCurrentUser = () => {
//   return new Promise((resolve, reject) => {
//     const removeListener = onAuthStateChanged(
//       getAuth(),
//       (user) => {
//         removeListener();
//         // Stocker l'Itilizatè dans un cookie avec une expiration
//         Cookies.set('user', JSON.stringify(user), { expires: 90 }); // Exemple : expire après 90 jours
//         resolve(user);
//         // console.log(Cookies);
//       },
//       reject
//     );
//   });
// }

const getCurrentUser = () => {
  // console.log('🔥 getCurrentUser start');
  
  // 🔥 Si Firebase a déjà l'Itilizatè en mémoire → réponse immédiate
  if (getAuth().currentUser !== null) {
    // console.log('🔥 getCurrentUser immédiat', getAuth().currentUser?.uid);
    return Promise.resolve(getAuth().currentUser);
  }

  // 🔥 Sinon attendre Firebase avec timeout de 3s
  return new Promise((resolve, reject) => {
    const removeListener = onAuthStateChanged(
      getAuth(),
      (user) => {
        removeListener();
        // console.log('🔥 getCurrentUser done', user?.uid);
        resolve(user);
      },
      reject
    );
    setTimeout(() => {
      // console.log('🔥 getCurrentUser timeout');
      removeListener();
      resolve(getAuth().currentUser);
    }, 3000);
  });
};


// router.beforeEach(async (to, from, next) => {
//   const user = await getCurrentUser();

//   if (to.path === "/" && user) {
//     next("/HomePage"); // ✅ Redirige vers une vraie page
//   } else if (to.matched.some((record) => record.meta.requiresAuth)) {
//     if (user) {
//       next();
//     } else {
//       store.commit('setShowDialog', true);
//       next("/");
//     }
//   } else {
//     next();
//   }
// });

router.beforeEach(async (to, from, next) => {
  const isNative = Capacitor.isNativePlatform();
  const isLocalhost = window.location.hostname === 'localhost' || 
                      window.location.hostname === '127.0.0.1';
  const isWeb = !isNative && !isLocalhost;

  // 🔥 Rediriger vers /install si web ET page principale
  const webRestrictedRoutes = ['/', '/HomePage'];
  if (isWeb && webRestrictedRoutes.includes(to.path) && to.name !== 'DisplayInstallAppPage') {
    next({ name: 'DisplayInstallAppPage' });
    return;
  }

  const user = await getCurrentUser();

  if (to.path === "/" && user) {
    next("/HomePage");
  } else if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (user) {
      next();
    } else {
      store.commit('setShowDialog', true);
      next("/");
    }
  } else {
    next();
  }
});


export default router;
